import { render } from "./IncomeConfirm.vue?vue&type=template&id=1ed4c71a&scoped=true"
import script from "./IncomeConfirm.vue?vue&type=script&lang=js"
export * from "./IncomeConfirm.vue?vue&type=script&lang=js"

import "./IncomeConfirm.vue?vue&type=style&index=0&id=1ed4c71a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed4c71a"]])

export default __exports__